'use client'

import { useEffect, useState } from 'react'

export default function ShareFacebook({
  children,
  url,
  title,
  className,
}: {
  children?: React.ReactNode
  url?: string
  title?: string
  className?: string
}) {
  const [shareUrl, setShareUrl] = useState<string>(url || '')

  useEffect(() => {
    if (!shareUrl) {
      const currentUrl = window.location.href
      setShareUrl(currentUrl)
    }
  }, [shareUrl])

  return (
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&hashtag=%23Hougarden.com&quote=${encodeURIComponent(title || '')}`}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      aria-label='Share on Facebook'
    >
      {children}
    </a>
  )
}
